import { ReactNode, useState } from "react";
import tw from "src/utils/tw";
import { useSearchParams } from "src/utils/useSearchParams";
import SlideDown from "../layout/SlideDown";

interface Props {
  className?: string;
  children?: ReactNode;
}

interface PanelProps {
  header: ReactNode;
  children?: ReactNode;
  showArrow?: boolean;
  initialOpen?: boolean;
  className?: string;
  paramKey?: string;
}

export function CollapsePanel(props: PanelProps) {
  const params = useSearchParams();
  const [open, setIsOpen] = useState(
    props.initialOpen || params.has(props.paramKey) || false
  );

  function handleClick() {
    setIsOpen((current) => !current);
  }

  return (
    <div className={tw("border-b border-borderGray", props.className)}>
      <div className="flex items-center px-4 py-4">
        <div className="flex-1 cursor-pointer" onClick={handleClick}>
          {props.header}
        </div>
        {props.showArrow && (
          <div>
            <i
              className={tw(
                "far",
                open ? "fa-circle-minus" : "fa-circle-plus",
                "text-organization"
              )}
            />
          </div>
        )}
      </div>
      <div className="px-4">
        <SlideDown>
          {open && <div className="pb-4">{props.children}</div>}
        </SlideDown>
      </div>
    </div>
  );
}

export function Collapse(props: Props) {
  return <div className="bg-white">{props.children}</div>;
}
